import $http from '@/api/index';
import store from '@/store';
import LRU from 'lru-cache';

const authUrl = '/api/authorization';
const cache = new LRU({ maxAge: 1000 * 60 });

/**
 * Asks API if the current logged staff has the given permissions.
 * @param {CheckStaffPermissionPayload[]} permissions
 * @return {Promise<CheckStaffPermissionResponse[]>}
 */
const query = async (permissions) => {
  try {
    const context = store.getters.context;
    const postData = { context, permissions };
    const cacheKey = `${authUrl}-${JSON.stringify(postData)}`;

    let permissionData = cache.get(cacheKey);
    if (permissionData === null || permissionData === undefined) {
      /** @var {{permissions: CheckStaffPermissionResponse[]}} */
      const response = await $http.post(authUrl, postData);
      if (response && response.permissions) {
        permissionData = response.permissions;
      } else {
        permissionData = [];
      }
      cache.set(cacheKey, permissionData);
    }

    return permissionData;
  } catch (response) {
    console.error('Couldn\'t authorize the given permissions request: ', permissions);
    if (response && Array.isArray(response.errors)) {
      response.errors.forEach(error => console.debug(error.reason));
    }
    return [];
  }
};

export default {
  query,
};
